export default {
  data() {
      return {
        hasOverflow: false,
        observedElement: null,
        cardContentObserver: null,
        intersectionObserver: null,
        cardContentVisibleHeight: 0,
        arrowAlignment: 'bottom'
      }
  },
  methods: {
    observeForOverflow() {
      this.cardContentObserver = new ResizeObserver(() => {
        if (this.observedElement) {
          let hadOverflow = this.hasOverflow

          // arrow should appear if more than 50 pixels of content are offscreen
          this.hasOverflow = this.observedElement.scrollHeight > this.observedElement.clientHeight + 50
          this.cardContentVisibleHeight = this.observedElement.clientHeight

          // reset arrow alignment if going from non-scroll to scroll
          if (!hadOverflow && this.hasOverflow) {
            this.arrowAlignment = 'bottom'
          }
        }
      })

      if (this.observedElement) {
        this.cardContentObserver.observe(this.observedElement)
      }
    },
    observeForIntersection(element) {
      this.intersectionObserver = new IntersectionObserver(this.onElementIntersection, { threshold: 0, rootMargin: "0px" })

      this.intersectionObserver.observe(element)
    },
    onElementIntersection(entries) {
      // if element comes into view flip the arrow back up since we've hit
      //   the bottom of the list, and dont want arrow to collide with the given element
      if (entries && entries[0].isIntersecting) {
        this.arrowAlignment = 'top'
      }
    },
    onScrollContentResize(navTotalOffset) {
      let hadOverflow = this.hasOverflow

      // if there is scrollable content enough that nav is offscreen, show arrow
      this.hasOverflow = this.observedElement.scrollHeight - navTotalOffset > window.innerHeight
      this.cardContentVisibleHeight = window.innerHeight

      // reset arrow alignment if going from non-scroll to scroll
      if (!hadOverflow && this.hasOverflow) {
        this.arrowAlignment = 'bottom'
      }
    },
    instantScroll(direction) {
      if (direction === 'up') {
        this.observedElement.scrollTop = 0
      } else {
        this.observedElement.scrollTop =  this.observedElement.scrollHeight
      }
    },
    onScroll(e) {
      const srcElement = e.srcElement.scrollingElement || e.srcElement
      const newArrowAlignment = this.arrowAlignmentForScroll(srcElement)

      if (newArrowAlignment) {
        this.arrowAlignment = newArrowAlignment
      }
    },
    arrowAlignmentForScroll(srcElement) {
      let scrolledDistance = srcElement.scrollTop
      let visibleHeight = srcElement.clientHeight
      let listHeight = srcElement.scrollHeight

      // change arrow direction when we get to the top or bottom of the list
      if (Math.abs(Math.ceil(scrolledDistance + visibleHeight) - listHeight) <= 1) {
        // we are at the bottom of the list and want the up arrow
        return 'top'
      } else if (scrolledDistance === 0) {
        // we are at the top of the list and want the down arrow
        return 'bottom'
      } else {
        return null
      }
    },
  },
  computed: {
    overlayStyle() {
      // default style for ScrollArrow - can be overridden
      return {
        height: this.cardContentVisibleHeight + 'px'
      }
    }
  }
}
